import { useEffect, useState } from 'react';
import { RectificationsByProductReportOrdering } from '../enum/ReportTableOrders';
import { setRectificationsByProductFilters } from '../../store/slices/reportsSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { rectificationsByProductFiltersSelector } from '../../store/selectors/reportsSelectors';
import { rectificationsByProductOrderingSelector } from '../../store/selectors/coreOrderingSelectors';
import { getRectificationByProductOrderingThunk } from '../../store/thunks/core/coreOrderingThunks';
import { initPaging } from '../../core/types/coreTypes';

export const useRectificationsByProductReportDefaultPaging = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(rectificationsByProductFiltersSelector);
  const ordering = useAppSelector(rectificationsByProductOrderingSelector);
  const [defaultOrder, setDefaultOrder] = useState<number | null>(null);

  useEffect(() => {
    if (!ordering.length) {
      dispatch(getRectificationByProductOrderingThunk());
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!filters.order?.field) {
      const defaultOrdering = ordering.find((el) => el.label === RectificationsByProductReportOrdering.UsedInRectifications)?.value;
      if (defaultOrdering) {
        setDefaultOrder(defaultOrdering);
        dispatch(setRectificationsByProductFilters({ ...filters, order: { field: defaultOrdering, isAsc: false } }));
      }
    }
    // eslint-disable-next-line
  }, [ordering]);

  return {
    ...initPaging,
    order: defaultOrder ? { field: defaultOrder, isAsc: false } : filters.order,
  };
};
